import { render } from "./DetalleView.vue?vue&type=template&id=2702d8e8"
import script from "./DetalleView.vue?vue&type=script&lang=js"
export * from "./DetalleView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__